// extracted by mini-css-extract-plugin
export default {"onboarding":"OnBoardingFlow_onboarding__n7fUA","onboarding-step5":"OnBoardingFlow_onboarding-step5__dA8LI"};